export enum ProductType {
  ACCOMMODATION = 'accommodation',
  SERVICE = 'service',
  PACKAGE = 'package',
}
